<div class="select-version">
    <h2 class="mat-dialog-title">
        {{ "select_version.title" | translate }}
    </h2>
    <h3 *ngIf="data.isLogin" class="mat-dialog-subtitle">({{ "select_version.sub_title" | translate }})</h3>
    <h3 *ngIf="!data.isLogin" class="mat-dialog-subtitle">({{ "select_version.sub_title_choose_default" | translate }})</h3>
    <mat-dialog-content>
        <mat-radio-group [(ngModel)]="chooseVersion" (change)="chooseVersionChange()">
            <div class="row px-1 py-1">
                <div class="col-6 options" [ngStyle]="{
                    'background-image': 'url(' + urlPhoto + ')' 
                }">
                    <!-- <div class="options-image">
                        <img [src]="vContract" alt="vContract">
                    </div> -->
                    <p class="options-title">vContract</p>
                    <p class="options-sub-title">{{ "select_version.v_contract_title" | translate }}</p>
                    <mat-radio-button [value]="1"></mat-radio-button>
                </div>
                <div class="col-6 options">
                    <!-- <div class="options-image">
                        <img [src]="sContract" alt="sContract">
                    </div> -->
                    <p class="options-title">sContract</p>
                    <p class="options-sub-title">{{ "select_version.s_contract_title" | translate }}</p>
                    <mat-radio-button [value]="2"></mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
        <div *ngIf="data.isLogin" class="remember">
            <mat-checkbox [(ngModel)]="isRemember" class="remember-checkbox">{{ "select_version.remember_choice" |
                translate }}</mat-checkbox>
        </div>
    </mat-dialog-content>

    <div class="w-100 mat-dialog-draggable-footer">
        <mat-dialog-actions align="center">
            <button *ngIf="data.isLogin" mat-stroked-button color="primary" class="mr-3" type="button"
                (click)="onNoClick()">
                {{'button.logout' | translate}}
            </button>
            <button *ngIf="!data.isLogin" mat-stroked-button color="primary" class="mr-3" type="button"
                (click)="onNoClick()">
                {{'button.cancel' | translate}}
            </button>
            <button mat-raised-button type="button" color="primary" (click)="onClickBtnConfirm()">
                {{'select_version.button.confirm'| translate}}
            </button>
        </mat-dialog-actions>
    </div>
</div>